import React from 'react';
import tw from 'twin.macro';
import Link from '@teetsh/app/src/components/Link';
import clsx from 'clsx';

const linkStyle = tw`hover:underline`;

interface Props {
  url?: string;
  internalLink?: string;
  label?: string;
  children?: React.ReactNode;
  className?: string;
  onClick?: (e?: React.MouseEvent) => void;
}

export function ExternalOrInternalLink(props: Props) {
  const { url, label, internalLink, children } = props;
  if (internalLink) {
    return (
      <Link
        css={linkStyle}
        className={clsx(props.className)}
        onClick={e => {
          if (props.onClick) {
            props.onClick(e);
          }
          e.stopPropagation();
        }}
        to={internalLink}
      >
        {label || children}
      </Link>
    );
  }
  return (
    <a
      onClick={e => e.stopPropagation()}
      className={clsx(props.className)}
      href={url}
      rel="noreferrer noopener"
      css={[linkStyle, tw`text-primary`]}
      target="_blank"
    >
      {label || children}
    </a>
  );
}
